import { MRT_RowData } from "material-react-table";
import { DelayedSearch } from "src/utils/useDelayedSearch";
import { FoodsCheckbox } from "@foodpilot/foods";
import { SearchBar } from "src/components/SearchBar/SearchBar";
import { Box, Stack, useTheme } from "@mui/material";
import { CustomMRTFilter } from "../mrt.types";
import { onChangeManyFromMany } from "./onChangeManyFromMany";
import { Fragment } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import type { ComponentAppearance } from "src/components/appearance";

type DisplayStrategy = "radio" | "checkbox";

export type DisplayApi<SelectData> = {
    kind: DisplayStrategy;
    values: SelectData[];
    getId: (item: SelectData) => string | number;
    getName: (item: SelectData) => string | number;
    getLabel?: (item: SelectData) => string | number;
    getValue?: (item: SelectData) => string | number;
};

export const filterValueOf = <SelectData,>(selectOptions: DisplayApi<SelectData>, item: SelectData) =>
    (selectOptions.getValue ?? selectOptions.getName)(item);

type SelectManyFromFilterProps<T extends MRT_RowData, SelectData> = {
    appearance?: ComponentAppearance;
    mrtProps: CustomMRTFilter<T>;
    searchApi?: DelayedSearch;
    selectOptions: DisplayApi<SelectData>;
};
export const SelectManyFromFilter = <DataT extends MRT_RowData, SelectData>(
    props: SelectManyFromFilterProps<DataT, SelectData>,
) => {
    const { appearance = "legacy", searchApi, selectOptions, mrtProps } = props;
    const theme = useTheme();
    const { t } = useTranslation();

    const _currentFilters = mrtProps.column.getFilterValue();
    const currentFilters: (string | number)[] =
        _currentFilters === undefined || _currentFilters === null ? []
        : Array.isArray(_currentFilters) ? _currentFilters
        : [_currentFilters];

    const selectedItems = selectOptions.values.filter((item) => {
        return currentFilters.includes(filterValueOf(selectOptions, item));
    });

    return (
        <Stack gap={theme.spacing(2)}>
            {searchApi !== undefined && (
                <Fragment>
                    <Stack>
                        <SearchBar
                            search={searchApi.search}
                            setSearch={searchApi.setSearch}
                            placeholder={
                                appearance === "product-v2" ?
                                    t("component.select.searchplaceholder", "Search options…")
                                :   "Rechercher une marque..."
                            }
                            // eslint-disable-next-line jsx-a11y/no-autofocus -- filter popover opens on user action
                            autoFocus
                        />
                    </Stack>
                    <HorizontalBar />
                </Fragment>
            )}
            <Stack
                paddingLeft={theme.spacing(1)}
                sx={appearance === "product-v2" ? { maxHeight: theme.spacing(37.5), overflowY: "auto" } : undefined}
            >
                {selectOptions.kind === "checkbox" ?
                    <FoodsCheckbox
                        values={selectOptions.values}
                        getId={selectOptions.getId}
                        getName={selectOptions.getName}
                        selectedItems={selectedItems}
                        onChange={(newValues) => {
                            onChangeManyFromMany({ mrtProps, newValues, selectOptions });
                        }}
                    />
                :   null}
            </Stack>
        </Stack>
    );
};

const HorizontalBar = () => {
    const theme = useTheme();
    return <Box width={"70%"} alignSelf={"center"} borderBottom={`1px solid ${theme.custom.grey[500]}`} />;
};
